import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/public/blog").then(({ data }) => setPosts(data.posts || [])); }, []);
  return (
    <div className="min-h-screen bg-panel-bg text-panel-text">
      <Seo title="Blog | smsonay.site - SMS Onay Rehberleri" description="SMS onay, sanal numara ve hesap doğrulama hakkında rehberler ve ipuçları." />
      <PublicHeader />
      <section className="mx-auto max-w-5xl px-4 sm:px-6 py-12">
        <h1 className="font-head text-4xl font-extrabold tracking-tight">Blog</h1>
        <p className="text-panel-secondary mt-2">SMS onay ve sanal numara rehberleri.</p>
        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          {posts.map((p) => (
            <Link to={`/blog/${p.slug}`} key={p.slug} data-testid={`blog-post-${p.slug}`} className="card overflow-hidden hover:border-brand-500 transition-colors group">
              {p.cover && <img src={p.cover} alt={p.title} className="h-44 w-full object-cover" />}
              <div className="p-5">
                <h2 className="font-head font-semibold text-lg group-hover:text-brand-500 transition-colors">{p.title}</h2>
                <p className="text-sm text-panel-secondary mt-2 line-clamp-2">{p.excerpt}</p>
                <span className="text-xs text-panel-muted mt-3 block">{(p.created_at || "").slice(0, 10)}</span>
              </div>
            </Link>
          ))}
          {posts.length === 0 && <div className="text-panel-muted col-span-2 text-center py-16">Henüz yazı eklenmedi.</div>}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
